// This file is generated automatically by the buildInfo script
export const buildInfo = {
  coreBuildDate: '28/8/2024, 13:59:20',
  coreVersion: '4.40.0-SNAPSHOT',
  coreRevision: '3574ba7730caac7cac18a26511d2bc457798cf4d',
  coreBranch: 'main'
};
